// @ts-nocheck

import React, { useContext, useEffect } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import LabelTextItem from "../../../LabelTextItem";
import Icon from "../../../../brand/Icon";
import { SingleFileProps } from "./SingleFile.props";
import styles from "./SingleFile.module.scss";

import Button from "../../../Button";

import { FormContext } from "../../../Form";

const SingleFile: React.FC<SingleFileProps> = ({
  id,
  className,
  fileFormats,
  size = "xsmall",
  labelPosition = "top",
  label,
  name,
  required,
  validate,
  isLoading = false,
  onChange,
}: SingleFileProps): JSX.Element => {
  const { register, setValue } = useContext(FormContext);

  const wrapperClasses = cn(
    styles["singleFile-input-wrapper"], // static class for css
    styles[labelPosition],
    className,
  );

  const fileButtonClasses = cn(
    styles["file-btn"], // static class for css
    styles[labelPosition],
  );

  const iconClasses = cn(
    styles["button-icon"], // static class for css
    styles["upload-arrow-svg"],
  );

  /* "custom register" technique of react-hook-form
     this is so setValue doesn't try to set the value back to the input
     which fails for file inputs */
  useEffect(() => {
    register(name, { validate, required });
  }, [register, validate]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.files ? Array.from(e.target.files) : null;
    setValue(name, value);
    onChange && onChange();
  };

  let component = null;

  const labelText = (): string => {
    if (label) return label;
    return "Upload Files";
  };

  if (isLoading) {
    component = <Skeleton height={40} />;
  } else {
    component = (
      <div className={wrapperClasses}>
        <LabelTextItem
          id={`${id}-title-and-description-label`}
          className={styles["upload-title-description"]}
          label={labelText()}
          body={`Supported file formats are ${fileFormats}`}
        />
        <Button className={fileButtonClasses} size={size} tier="secondary" color="turquoise" ariaLabel="Select a File to Upload">
          <label htmlFor={`single-file-input-${id}`} className={styles["file-label"]} data-testid={`test__${id}-upload-btn`}>
            <Icon id={id} name="download" size={size === "xsmall" ? "small" : "medium"} color="turquoise" className={iconClasses} />
            <span className={styles["file-label-text"]}>SELECT A FILE</span>
          </label>
        </Button>
        <input
          accept={fileFormats}
          className={styles["inputUploadFile"]}
          id={`single-file-input-${id}`}
          // This just needs to be set to true and this component will accept multiple files though more handling required
          multiple={false}
          type="file"
          data-testid={`test__${id}-input`}
          onChange={handleFileChange}
          /* For handling clearing of file selection which clears the hook-form value only,
             and for handling reselect of same file which normally doesn't re-trigger
             onChange even if the selected file's content has been changed since the
             previous selection. */
          onClick={(e) => (e.currentTarget.value = "")}
        />
      </div>
    );
  }

  return component;
};

export default SingleFile;
